import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=3befc0ee&scoped=true"
import script from "./LinksList.vue?vue&type=script&lang=js"
export * from "./LinksList.vue?vue&type=script&lang=js"
import style0 from "./LinksList.vue?vue&type=style&index=0&id=3befc0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3befc0ee",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Flinks-list%2FLinksList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports